import React, { Component } from 'react';


export default class Anchor extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (<div>
            <h3 style={{
                textAlign: 'center',
                fontWeight: 'bold',
                margin: '50px 0 20px',
                fontFamily: '宋体',
                color: '#000'
            }}>会员自动续费服务协议</h3>
            <div style={{
                marginBottom: "20px",
                fontSize: '14px',
                fontFamily: '宋体',
                padding: '0 15px',
                color: '#000'
            }}>
                本规则被视为《呼呼收音机VIP会员服务协议》的补充协议，是其不可分割的组成部分，与其具有同等法律效力。如本规则与《呼呼收音机VIP会员服务协议》存在冲突的，以本规则为准。请您在点击“开通”使用呼呼收音机VIP会员自动续费服务前，仔细阅读本规则条款。当您开通呼呼收音机VIP会员自动续费服务时视为您已充分理解并同意如下使用规则：<br />

                1.本服务是在您已开通呼呼收音机VIP会员服务的前提下，为您提供的自动续费服务。如您开通本服务，则视为您授权呼呼收音机公司有权在您的呼呼收音机VIP会员即将到期时，从您的iTunes账户（以下统称“账户”）余额中代扣下一个服务周期的服务费，服务周期包括但不限于1个月、1年、2年、3年等（具体以您实际选择开通的服务周期为准）。在开通本服务后，请确保您已将所开通的呼呼收音机VIP会员账号与上述账户绑定，且账户余额不少于服务费用。若因您未绑定账户或所绑定的账户中可扣款余额不足而导致的续费失败，由您自行承担。<br />

                2.开通自动续费服务的账号，会在每个服务周期到期前24小时，自动在iTunes账户扣费并按对应的期限延长您的会员有效期。如需取消订阅，请手动打开苹果手机“设置” --进入“iTunes Store 与 App Store”--点击“Apple ID”，选择"查看Apple ID"，进入"账户设置"页面，点击“订阅”，选择呼呼收音机VIP会员服务取消订阅即可。如未在订阅期结束的至少24小时前关闭订阅的，将视为您同意继续授权，此订阅将会自动续订。<br />



                杭州叽里咕噜文化传播有限公司
            </div>
        </div>);
    }
}